






















// import Vue from "vue";
import { Component } from "vue-property-decorator";
import Button from "@/components/Button.vue"
import { mixins } from 'vue-class-component';
import TagHelper from '@/mixins/TagHelper'
import FormItem from "@/components/Money/FormItem.vue";
import Dialog from "@/components/Dialog.vue";

@Component({
  components: {
    Button,
    FormItem,
    Dialog
  },
})
export default class Labels extends mixins(TagHelper) {
  get tags() {
    return this.$store.state.tagList
  }

  created() {
    this.$store.commit('fetchTags')
  }
}
